/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

/**
 * @typedef DynamicFieldProviderProps
 * @property {number} position
 * @property {object} field
 * @property {React.ReactNode} children
 */

import { DynamicFieldContext } from "./dynamic-field-context";

/**
 * @param {DynamicFieldProviderProps} props
 */
export function DynamicFieldProvider (props) {
    const position = props?.position;
    const children = props?.children;

    return (
        <DynamicFieldContext.Provider value={{ position }}>
            {children}
        </DynamicFieldContext.Provider>
    );
}
